// import React, {useState, useEffect} from 'react';
// import {
//   ListItem,
//   ListItemText,
//   Divider,
// } from '@mui/material';
// import {Link} from 'react-router-dom';
// import {EvaluarPermiso} from '../../Genericos/Generales';

// const Dashboard = props => {
//   const classes = props.classes;
//   const sesionUsuario = props.sesionUsuario;

//   useEffect (() => {
//     VerificarPermisos (
//       sesionUsuario.usuario.pantallasUsuario.listaPantallasRol
//     );
//   }, [sesionUsuario]);

//   const [dashboard, setDashboard] = useState (false);

//   const VerificarPermisos = arrPermisos => {
//     setDashboard (EvaluarPermiso (arrPermisos, '/'));
//   };

//   return (
//     <React.Fragment>
//       {dashboard
//         ? <ListItem
//             component={Link}
//             button
//             to="/"
//             className={classes.listItemText}
//           >
//             <i notranslate="true" className="material-icons">
//               dashboard
//             </i>
//             <ListItemText
//               classes={{primary: classes.listItemText}}
//               primary="DashBoard"
//             />
//           </ListItem>
//         : null}
//       {dashboard ? <Divider /> : null}
//     </React.Fragment>
//   );
// };

// export default Dashboard;
import React, { useState, useEffect } from 'react';
import { ListItem, ListItemText, ListItemIcon } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { Link } from 'react-router-dom';
import { EvaluarPermiso } from '../../Genericos/Generales';

const Dashboard = ({ sesionUsuario }) => {
  const [dashboard, setDashboard] = useState(false);

  useEffect(() => {
    VerificarPermisos(sesionUsuario.usuario.pantallasUsuario.listaPantallasRol);
  }, [sesionUsuario]);

  const VerificarPermisos = arrPermisos => {
    setDashboard(EvaluarPermiso(arrPermisos, '/'));
  };

  return (
    <>
      {dashboard && (
        <ListItem
          component={Link}
          button
          to="/"
          sx={{
            mx: 1,
            my: 0.5,
            borderRadius: 2,
            transition: 'all 0.2s ease',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.08)',
              transform: 'translateX(4px)',
            },
          }}
        >
          <ListItemIcon sx={{ minWidth: 40, color: 'primary.main' }}>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText
            primary="Dashboard"
            sx={{
              '& .MuiListItemText-primary': {
                fontWeight: 600,
                color: 'text.primary',
              },
            }}
          />
        </ListItem>
      )}
    </>
  );
};

export default Dashboard;
